import { createFileRoute } from '@tanstack/react-router';
import type { JSX } from 'react';

import { DuplicateResourceForm } from '@/areas/manufacturing-templates/Resources/ResourceCreation/DuplicateResourceForm';
import { canCreateManufacturingTemplates } from '@/shared/permissions/pagePermissions';
import type { PageStaticData } from '@/shared/routing';
import { PageLayout } from '@/shared/ui/PageLayout';

export const Route = createFileRoute('/_authenticated/next/templates/manufacturing/resources/$resourceId/duplicate')({
    staticData: { access: { permissions: canCreateManufacturingTemplates }, chrome: 'none' } satisfies PageStaticData,
    component: RouteComponent,
});

function RouteComponent(): JSX.Element {
    const pathParams = Route.useParams();
    return (
        <PageLayout layout="full-width">
            <DuplicateResourceForm resourceId={pathParams.resourceId} />
        </PageLayout>
    );
}
